module.exports = __webpack_public_path__ + "img/Component 4 – 90.ac462669.svg";